import { render, staticRenderFns } from "./PlateForm.vue?vue&type=template&id=2a754d74"
import script from "./PlateForm.vue?vue&type=script&lang=js"
export * from "./PlateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports